import { useGetAccountSubscriptionInfoQuery } from '../store/facade/facadeApiV2';

export const useAccountSubscription = () => {
    const { currentData, isError, isLoading } = useGetAccountSubscriptionInfoQuery();
    if (isError || (!isLoading && !currentData)) {
        throw new Error('Was not able to get the account subscription state');
    }
    return { subscribed: currentData, isLoading };
};
